import apiService from './apiService';
import gatewayApiService from './apiGatewayService';

const api = {
  Common: {
    GetTTJUrl(data) {
      return apiService('common', 'getTTJUrl', 'GET', data, '');
    },
    CheckAuthToken(data) {
      return apiService('common', 'authLogin/checkAuthToken', 'POST', data, '');
    },
    GetRandomKey(data) {
      return apiService('common', 'getRandomKey', 'POST', data, '');
    },
    // 退出
    Logoout(data) {
      return apiService('common', 'logout', 'POST', data, '');
    },
    // 设置
    Setting(data) {
      return apiService('common', 'setting/main', 'POST', data, '');
    },
    IdentityAuth(data) {
      // 实名认证
      return apiService(
        'common',
        'certification/identityAuth',
        'POST',
        data,
        '',
        true,
      );
    },
    QueryAllProvCities(data) {
      // 查取省市
      return apiService(
        'fund',
        'withdraw/queryAllProvCities',
        'POST',
        data,
        '',
      );
    },
    QueryAllProvCityZones(data) {
      return apiService('subMerchant/register', 'queryAllProvCities', 'POST', data, '');
    },
    QueryBranches(data) {
      // 查取分支行
      return apiService('fund', 'withdraw/queryBranches', 'POST', data, '');
    },
    CheckCardNoMobile(data) {
      // 找回支付密码
      return apiService(
        'wallet',
        'paypassword/check-cardNo-mobile',
        'POST',
        data,
      );
    },
    GetCommonUrl(data) {
      return apiService('common', 'getCommonUrl', 'GET', data, '', true);
    },
    // 新增图形验证校验
    PreCheckCaptchaCode(data) {
      return apiService(
        'common',
        'captcha/preCheckCaptchaCode',
        'POST',
        data,
        '',
        true,
      );
    },
  },
  User: {
    GetUserInfo(data) {
      return apiService('wallet/member', 'getUserAssets', 'POST', data, '');
    },
  },
  Wallet: {
    ForgetPassword(data) {
      // 忘记支付密码
      return apiService(
        'wallet/paypassword',
        'forgetPayPassword',
        'POST',
        data,
        '',
      );
    },
    GetSupportBankAndLimit(data) {
      // 銀行卡限額(收银台)
      return apiService(
        'cashier',
        'merchantConf/getSupportBankAndLimit',
        'POST',
        data,
        '',
      );
    },
    GetBankLimit(data) {
      // 銀行卡限額(钱包)
      return apiService('common', 'setting/getBankLimit', 'POST', data, '');
    },
    GetAllBankCard(data) {
      // 银行卡管理
      return apiService('wallet', 'card/getAllBankCard', 'POST', data, '');
    },
    RemoveBankCard(data) {
      // 银行卡删除
      return apiService('wallet', 'card/removeBankCard', 'POST', data, '');
    },
    getNoticeDetail(data) {
      // APP公告详情
      return apiService('wallet', 'notice/getNoticeDetail', 'POST', data, '');
    },
    SendAuthCode(data) {
      // 发送手机验证码
      return apiService('register', 'sendAuthCode', 'POST', data, '');
    },
    DoRegister(data) {
      // 确认注册
      return apiService('register', 'doRegister', 'POST', data, '', true);
    },
    SetPayPassword(data) {
      return apiService(
        'wallet',
        'paypassword/setShortPayPwd',
        'POST',
        data,
        '',
        true,
      );
    },
    SetLoginPwdAndActive(data) {
      // 设置登录密码并激活
      return apiService(
        'register',
        'setLoginPwdAndActive',
        'POST',
        data,
        '',
        true,
      );
    },
    ApplyWithdraw(data) {
      // 申请提现
      return apiService(
        'wallet/withdraw',
        'applyWithdraw',
        'POST',
        data,
        '',
        true,
      );
    },
    NewWithdrawApply(data) {
      // 申请提现（新） 20190102
      return apiService(
        'wallet/withdraw',
        'newWithdrawApply',
        'POST',
        data,
        '',
        true,
      );
    },
    QueryWithdrawInfo(data) {
      return apiService(
        'wallet/withdraw',
        'queryWithdrawInfo',
        'POST',
        data,
        '',
        true,
      );
    },
    QueryCardInfoList(data) {
      // 查询银行卡列表
      return apiService('wallet/withdraw', 'queryCardInfoList', 'POST', data);
    },
    QueryLimits(data) {
      // 查询限额
      return apiService('wallet/withdraw', 'queryLimits', 'POST', data);
    },
    QueryNeedBankBranch(data) {
      // 是否需要分支行
      return apiService('wallet/withdraw', 'queryNeedBankBranch', 'POST', data);
    },
    QuerySerivceCharge(data) {
      // 服务费
      return apiService('wallet/withdraw', 'querySerivceCharge', 'POST', data);
    },
    CheckCardBin(data) {
      // 检查卡
      return apiService('wallet', 'card/checkCardBin', 'POST', data);
    },
    GetRealName(data) {
      // 查询实名
      return apiService('wallet', 'card/getRealName', 'POST', data);
    },
    InputMobile(data) {
      // 落地签约信息
      return apiService('wallet', 'card/inputMobile', 'POST', data);
    },
    VerifyAuthCode(data) {
      // 校验验证码信息
      return apiService(
        'wallet',
        'card/verifyAuthCode',
        'POST',
        data,
        '',
        true,
      );
    },
    BindingMobile(data) {
      // 绑定手机号
      return apiService(
        'common',
        'setting/bindingMobile',
        'POST',
        data,
        '',
        true,
      );
    },
    GetVerifyCode(data) {
      // 获取验证码
      return apiService('common', 'setting/getVerifyCode', 'POST', data);
    },
    CheckPayPwd(data) {
      // 判断短密支持
      return apiService('wallet', 'paypassword/checkPayPwd', 'POST', data);
    },
    ValidatePayPwd(data) {
      // 校验支付密码
      return apiService(
        'wallet',
        'paypassword/validatePayPwd',
        'POST',
        data,
        '',
        true,
      );
    },
    SetPayPwd(data) {
      // 设置支付密码
      return apiService('wallet', 'password/setPayPwd', 'POST', data, '', true);
    },
    SetPwd(data) {
      // 设置登录密码、支付密码
      return apiService('wallet', 'password/setPwd', 'POST', data, '', true);
    },
    GetLatestAppVersion(data) {
      // 获取APP信息
      return apiService('appVersionAction', 'getLatestAppVersion', 'POST', data);
    },
    AppRegisterAdvance(data) {
      return apiService('appRegisterAction', 'advance', 'POST', data, '', true);
    },
    AppRegisterApply(data) {
      return apiService('appRegisterAction', 'apply', 'POST', data, '', true);
    },
    QueryAccountBalance(data){
      return apiService('wallet', 'accountBalance/queryAccountBalance', 'POST', data, '', true);
    }
  },
  Fund: {
    SendSMS(data) {
      // 发送验证码
      return apiService('fund', 'sms/sendSMS', 'POST', data, '', true);
    },
    // 新增图形验证码
    SendSMSCaptcha(data) {
      return apiService('fund', 'sms/sendSMSCaptcha', 'POST', data, '', true);
    },
    CheckVerifyCode(data) {
      // 较验证码
      return apiService('fund', 'sms/checkVerifyCode', 'POST', data, '', true);
    },
    FindLoginPassword(data) {
      return apiService('fund', 'password/find-loginPassword', 'POST', data);
    },
    CheckAccount4FindPwd(data) {
      return apiService(
        'fund',
        'member/checkAccount4FindPassword',
        'POST',
        data,
        null,
        true,
      );
    },
  },
  Other: {
    GetWeather(data) {
      return apiService('json', 'mobile_tel_segment.htm', 'GET', data);
    },
  },
  Wechat: {
    GetAliServiceUrl(data) {
      // 在线客服
      return apiService('wechat', 'customer/getAliCustomUrl', 'POST', data);
    },
    GetMemberTypeAndOperators(data) {
      // 在线客服
      return apiService(
        'wechat',
        'login/getMemberTypeAndOperators',
        'POST',
        data,
      );
    },
    CheckCaptcha(data) {
      return apiService(
        'wechat/merchantCooperation',
        'checkCaptchaCode',
        'POST',
        data,
        '',
      );
    },
  },
  Auth: {
    PasswordLogin(data) {
      return apiService('oauth', 'passwordLogin', 'POST', data, '', true);
    },
    AuthSmsLoginAdvance(data) {
      return apiService('oauth', 'authSmsLoginAdvance', 'POST', data, '', true);
    },
  },
  Rebind: {
    BaseInfoSubmit(data) {
      return apiService('selfservice', 'changemobile/advance', 'POST', data, '');
    },
    IdentityCheck(data) {
      return apiService('selfservice', 'changemobile/identityCheck', 'POST', data, '');
    },
    PreCheck(data) {
      return apiService('selfservice', 'changemobile/preCheck', 'POST', data, '', true);
    },
    QueryImgFiles(data) {
      return apiService('selfservice', 'changemobile/queryImgFiles', 'POST', data, '');
    },
    DoSubmit(data) {
      return apiService('selfservice', 'changemobile/submit', 'POST', data, '');
    },
  },
  gateWayApi: {
    GetGateWayApi(data) {
      return gatewayApiService('', 'api', 'POST', data);// 'newgateway/api-gateway'
    },
    UploadFile(data) {
      return gatewayApiService('', 'uploadFile', 'POST', data);// 'newgateway/api-gateway'
    },
    GetGateWayApiWithStatus(data) {
      return gatewayApiService('', 'api', 'POST', data, true);// 'newgateway/api-gateway'
    }
  },
};
export default api;



// WEBPACK FOOTER //
// ./src/service/APIs.js